function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopulationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384.1 384",
    style: {
      enableBackground: "new 0 0 384.1 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stroke_3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1ABF67"
    },
    d: "M372.4,55.7l-44.1-44.1c-15.5-15.5-40.7-15.5-56.2,0l-47.4,47.4c0,0,0,0-0.1,0.1c0,0,0,0-0.1,0.1 L109.3,174.5c-2.4,2.4-4,5.6-4.5,9.1L93,273.4c-0.6,4.8,1,9.7,4.5,13.2c3,3,7,4.6,11.1,4.6c0.7,0,1.4,0,2.1-0.1l89.9-11.9 c3.4-0.5,6.6-2,9.1-4.5l162.9-162.9C387.9,96.4,387.9,71.2,372.4,55.7z M191.1,248.7l-64.3,8.5l8.5-64.3L235.8,92.5l55.8,55.8 L191.1,248.7z M350.2,89.6L313.8,126L258,70.2l36.4-36.4c1.6-1.6,3.6-2.4,5.8-2.4c2.2,0,4.3,0.9,5.8,2.4l44.1,44.1 C353.4,81.2,353.4,86.4,350.2,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1ABF67"
    },
    d: "M348.8,233.3c-8.7,0-15.7,7-15.7,15.7v71.3c0,17.8-14.5,32.3-32.3,32.3H138.7H63.7 c-17.8,0-32.3-14.5-32.3-32.3v-74.9V83.3C31.5,65.5,45.9,51,63.7,51H135c8.7,0,15.7-7,15.7-15.7s-7-15.7-15.7-15.7H63.7 C28.6,19.6,0,48.2,0,83.3v162.1v74.9C0,355.5,28.6,384,63.7,384h74.9h162.1c35.1,0,63.7-28.6,63.7-63.7V249 C364.5,240.4,357.4,233.3,348.8,233.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationIcon);
export default __webpack_public_path__ + "static/media/population-icon.1aa93df57a99b11b9892bd9257b2f431.svg";
export { ForwardRef as ReactComponent };